<template>
  <div>
    <div style="height: 20px"></div>
    <!-- 媒体组件 -->
    <div class="media-box">
      <div class="media-item left-box">
        <btc-video v-if="item.VideoLink" :item="item" :is-price="true" style="height: 100%;width: 100%;min-width: 711px;margin: 0;border-radius: 0"/>
        <img v-if="!item.VideoLink" style="height: 100%;width: 100%" :src="item.ReportCover" alt="">
      </div>
      <div v-show="firstItem.ReportID === item.ReportID" class="media-item right-box">
        <div class="right-body">
          <div class="right-title">
            <h2>BTC Market Analysis</h2>
          </div>
          <div class="right-footer">
            <img style="margin-top: 10px;width: 18px;height: 15px" src="@/assets/image/price/analysis/up.png" alt="">
            <div style="margin-top: 60px;text-align: center;font-family: 'AbhayaLibre Regular';padding: 0 20px 0 10px">We deliver the market voices to the industrial listeners.</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 文章详情 -->
    <div class="article-details">
      <h5>{{ item.ReportTitle }}</h5>
      <div class="week-body">
        <div>
          <img src="@/assets/image/price/Date.png" alt="">
          <span>{{ handleDate(item.ReportTitle) }}</span>
        </div>
        <div v-show="isSwitch" class="week-language">
          <div v-for="(item, index) in langs" :key="index" class="hand" :class="{ active: current === index }" @click="handleLanguage(index)">
            <img v-if="current === index" src="@/assets/image/price/analysis/dot.png" alt="">
            <img style="width: 28px;height: 20px" :src="item.icon" :alt="item.lang" class="hand">
          </div>
        </div>
      </div>
      <div class="week-content">
        <input type="checkbox" id="contTab" checked="checked" class="tabbed">
        <div id="cont">
          <viewer v-if="item.ReportContent" :key="item.ReportID" :initialValue="item.ReportContent"/>
          <div style="width: 100%;display: flex;justify-content: flex-end">
            <img src="@/assets/image/price/analysis/logo.png" alt="" style="width: 170px;height: 50px;">
          </div>
        </div>
        <div class="content-more">
          <div class="gradient"></div>
          <label class="readme" @click="handleKeep">Keep Reading
            <img style="margin-left: 10px" src="@/assets/image/price/analysis/keep.png" alt="">
          </label>
        </div>
      </div>
    </div>
    <div class="divider"/>
    <div class="week-footer">
      <media-card v-for="(item,index) in list" :key="index" :item="item" @handleMedia="handleMedia(item,index)"/>
      <div class="week-more hand" @click="handleMore">
        <img src="@/assets/image/price/analysis/more.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import MediaCard from './components/media-card'
import BtcVideo from '@/components/BtcVideo'
import { Viewer } from '@toast-ui/vue-editor'
import commonmix from '@/utils/commonmix'
import { getLocalStore } from '@/utils/common'

export default {
  mixins: [commonmix],
  name: 'MarketAnalysis',
  components: {
    MediaCard,
    BtcVideo,
    Viewer
  },
  props: {
    defaultItems: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      current: 0,
      ListQuery: {
        PageNum: 1,
        PageSize: 3,
        ReportType: '_marketanalysis',
        LanguageCode: 'en',
        UserID: getLocalStore().UserID
      },
      list: [],
      item: {},
      firstItem: {},
      isSwitch: false,
      langIcon: [
        { lang: 'en', icon: require('@/assets/image/btcinfo/american.png') },
        { lang: 'spanish', icon: require('@/assets/image/btcinfo/spanish.png') },
        { lang: 'portuguese', icon: require('@/assets/image/btcinfo/portuguese.png') }
      ],
      currentIndex: 0
    }
  },
  mounted () {
    this.getList()
  },
  computed: {
    isEnExpire () {
      return this.getUserProfile(this.$t('message._beefprice_en'))
    },
    langs () {
      if (this.list.length) {
        const newArr = [...this.list[this.currentIndex].Langs]
        if (newArr.length !== 0) {
          newArr.unshift('en')
        }
        const arr = []
        newArr.forEach(item => {
          this.langIcon.forEach((v, index) => {
            if (v.lang === item) {
              arr.push(this.langIcon[index])
            }
          })
        })
        return arr
      }
      return []
    }
  },
  methods: {
    getList () {
      this.$store.dispatch('SetLoadingStatus', true)
      this.$store.dispatch('GetWebFrontMarketReport', this.ListQuery).then(() => {
        this.firstItem = this.$store.getters.priceRows[0]
        this.list = this.defaultItems.length === 0 ? this.$store.getters.priceRows : this.defaultItems
        this.item = this.list[0]
        this.isSwitch = this.item.Langs.length !== 0
        this.$store.dispatch('SetLoadingStatus', false)
      }).catch((err) => {
        console.log(err)
        this.$store.dispatch('SetLoadingStatus', false)
      })
    },
    handleLanguage (index) {
      this.current = index
      if (index === 0) {
        this.item = this.list[0]
      } else {
        const listIndex = index - 1
        this.item = this.list[this.currentIndex].Recommendation[listIndex]
      }
    },
    handleMore () {
      this.$emit('handleMore')
    },
    handleMedia (item, index) {
      this.current = 0
      this.currentIndex = index
      this.item = item
      this.isSwitch = this.item.Langs.length
      window.scrollTo(0, 0)
    },
    handleDate (str) {
      if (str) {
        return str.substring(str.lastIndexOf('(') + 1, str.lastIndexOf(')'))
      }
    },
    handleKeep () {
      if (this.$store.getters.token) {
        if (this.isEnExpire || this.item.IsFree) {
          document.getElementById('contTab').checked = false
        } else {
          this.openMembershipModal()
        }
      } else {
        this.openLoginModal()
      }
    }
  }
}
</script>

<style lang="scss">
#cont .tui-editor-contents > h4 {
  font-size:18px!important;
  line-height: 27px;
  font-family:"AbhayaLibre Regular";
  word-break: normal!important;
}
</style>

<style lang="scss" scoped>
.media-box {
  height: 400px;
  display: flex;
  background: #ffffff;
}

.media-item {
  height: 100%;
}

.left-box {
  flex: 1;
}

.right-box {
  width: 280px;
  color: #F9F9F9;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.right-title {
  padding: 40px;
}

.right-title > h2 {
  font-family:"AbhayaLibre ExtraBold";
  font-size: 40px;
}

.right-body {
  height: 100%;
  overflow: hidden;
  position: relative;
  background-image: linear-gradient(to right, #055585, #014479);
}

.right-footer {
  height: 100%;
  background-image: linear-gradient(to right, #055585, #014479);
  text-align: center;
  transition: 0.3s;
  position: absolute;
  margin-top: 325px;
  top: 1px;
  z-index: 1;
}

.right-body :hover.right-footer {
  opacity: 1;
  transition: 0.3s;
  margin-top: 160px;
  font-size: 18px;
}

.article-details > h5 {
  flex: 1;
  text-align: center;
  margin: 20px 0;
  font-family:"AbhayaLibre ExtraBold";
  font-size: 24px!important;
}

.week-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.week-body > div:first-child {
  display: flex;
  align-items: center;
  font-size:20px!important;
  line-height: 27px;
  font-family:"AbhayaLibre ExtraBold";
}

.week-body > div:first-child > img {
  width: 20px;
  height: 20px;
  margin: 10px;
}

.week-language {
  height: 30px;
  max-width: 165px;
  background: #e6e6e6;
  border-radius: 8px;
  margin-right: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
}

.week-language > div {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
}

.week-language > div > img {
  padding: 2px;
}

.week-content {
  padding: 10px;
  height: 100%;
}

.active {
  border-radius: 10%;
  background: #ffffff;
}

.week-footer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.week-more {
  width: 40px;
  height: 100px;
  margin: 20px 0;
  border-radius: 10px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 1px 1px #e1e1e1;
}

/*阅读全文*/
.tabbed {
  display: none;
}

.content-more {
  display: none;
}

.tabbed:checked ~ #cont {
  max-height: 100px;
  overflow: hidden;
}

.tabbed:checked ~ .content-more {
  display: block;
  position: relative;
  padding: 40px 0 0 0;
  text-align: center;
}

.tabbed:checked ~ .content-more .gradient {
  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0)), to(#f5f5f5));
  background-image: -webkit-linear-gradient(top, rgba(255, 255, 255, 0), #f5f5f5);
  background-image: linear-gradient(-180deg, rgba(255, 255, 255, 0), #f5f5f5);
  height: 80px;
  position: absolute;
  left: 0;
  top: -79px;
  width: 100%;
}

.tabbed:checked ~ .content-more .readme {
  display: inline-block;
  background: #ffffff;
  color: #014479;
  width: 160px;
  height: 35px;
  border-radius: 35px;
  line-height: 35px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 1px 1px 1px #e1e1e1;
}

.divider {
  width: 100%;
  height: 2px;
  background-color: #FFFFFF;
}

</style>
